<app-header />

<div class="g-page g-container">

  <div class="page-section-1">
    <div class="section-catalog">
      <side-catalog-menu
        [categories]="categoryService.categories()"
        (openCatalogMenu)="openCatalogMenu()"
      />
    </div>

    <div class="section-banner">
      <banner />
    </div>
  </div>

  <ul class="categories">
    @for (category of categoryService.categories(); track category.i) {
      <li class="category">
        <a
          class="category-img-wrapper"
          [routerLink]="'/' + category.s"
          routerLinkWithLang
        >
          <img
            class="category-img"
            [src]="getCategoryImage(category)"
            [alt]="category.n"
            loading="lazy"
          >
        </a>

        <div class="category-info">
          <h2 class="category-title">
            <a class="g-main-link category-title-link" [routerLink]="'/' + category.s" routerLinkWithLang>{{ category.n }}</a>
          </h2>

          @if (category.c.length) {
            <ul class="category-subcategories">
              @for (subcategory of category.c; track subcategory.i) {
                <li>
                  <h3 class="category-subcategory">
                    <a class="g-main-link" [routerLink]="'/' + subcategory.s" routerLinkWithLang>{{ subcategory.n }}</a>
                  </h3>
                </li>
              }
            </ul>
          }
        </div>
      </li>
    }
  </ul>

  <section class="perks">
    <div class="perk">
      <i class="perk-img mbi mbi-rocket"></i>
      <div class="perk-info">
        <h4 class="perk-title">{{ 'index.perk_1_title' | translate }}</h4>
        <div class="perk-text">{{ 'index.perk_1_text' | translate }}</div>
      </div>
    </div>

    <div class="perk">
      <i class="perk-img mbi mbi-sync2"></i>
      <div class="perk-info">
        <h4 class="perk-title">{{ 'index.perk_2_title' | translate }}</h4>
        <div class="perk-text">{{ 'index.perk_2_text' | translate }}</div>
      </div>
    </div>

    <div class="perk">
      <i class="perk-img mbi mbi-credit-card2"></i>
      <div class="perk-info">
        <h4 class="perk-title">{{ 'index.perk_3_title' | translate }}</h4>
        <div class="perk-text">{{ 'index.perk_3_text' | translate }}</div>
      </div>
    </div>

    <div class="perk">
      <i class="perk-img mbi mbi-bubbles"></i>
      <div class="perk-info">
        <h4 class="perk-title">{{ 'index.perk_4_title' | translate }}</h4>
        <div class="perk-text">{{ 'index.perk_4_text' | translate }}</div>
      </div>
    </div>
  </section>

  <insta-widget />

  <recently-added-products />

  <section class="posts-list">
    <posts-preview [category]="'lastWorks'" />
    <posts-preview [category]="'lastPosts'" />
  </section>

  <recently-viewed-products />

</div>

<app-footer />
